




























































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import axios from 'axios';
import userService from '@/services/hub/user';
import AppHeaderGallery from '@/components/AppHeaderGallery.vue';
import { debounce } from 'lodash';
import { registerLog } from '@/services/hub/logsAction';
import jwtDecode from 'jwt-decode';
import StripePayment from '@/components/Payments/StripePayment.vue';

export default Vue.extend({
  name: 'ViewTranscription',
  components: {
    AppHeaderGallery,
    StripePayment,
  },
  data() {
    return {
      showModal: false,
      valid: false,
      folderId: 0,
      planOdId: 0,
      userToken: '' as any,
      customerPlansId: 0,
      folders: [] as any,
      breadcrumb: [],
      secretPlayer: '',
      searchUpload: '',
      availableVideos: [] as any,
      availableItems: [] as any,
      filteredItems: [] as any,
      searchQuery: '',
      selectedVideo: null as any,
      selectedTypeSubtitle: 'transcription',
      typeSubtitle: [
        { text: 'Gerar transcrição', value: 'transcription', sortable: false },
        // { text: 'Enviar arquivo de legenda', value: 'subtitle', sortable: false },
      ],
      subtitles: [] as any,
      searchSubtitle: '',
      filteredSubtitles: [] as any[],
      video: {
        id: '',
        name: '',
        description: '',
        fileUrl: '',
        thumbBaseUrl: '',
        hash: '',
        cover: '',
        storage_hash: '',
        parentId: '' as any,
        cdnUrl: '',
        filename: '',
        download_url: '',
        subtitles: [] as any,
        subtitle: '' as any,
      },
      languages: [
        { text: 'English', value: 'en-US' },
        { text: 'Portuguese', value: 'pt-BR' },
      ],
      id_customer: 0 as number,
      creditsAvailable: 0 as number,
      videoCredits: 0 as any,
      creditsToPurchase: 1,
      showPurchaseModal: false,
      selectedCredits: 0 as any,
      selectedLanguage: '',
      progress: 0,
      intervalId: null as any,
      isLoadedFromLocalStorage: false,
      username: '',
      showConfirmation: false,
      showConfirmationAgain: false,
      userEmail: '',
    };
  },
  computed: {
    translatedLanguages(): any {
      return this.languages.map((lang: any) => ({
        text: this.$t(lang.text),
        value: lang.value,
      }));
    },
  },
  watch: {},
  beforeDestroy() {
    this.stopProgressPolling();
  },
  async mounted() {
    await this.userInformation();
  },
  methods: {
    async userInformation() {
      const userInfo = localStorage.getItem('user');
      if (userInfo) {
        const user = JSON.parse(userInfo);
        this.selectedLanguage = this.$route.params.language;

        const { token } = user;
        const decodedToken = jwtDecode(token) as any;
        console.log('Decoded Token:', decodedToken);
        this.username = decodedToken.sub.nickname;
        this.id_customer = decodedToken.sub.id_customers;
        this.customerPlansId = user.user.plan_id;
        this.userToken = user.token;
        this.userEmail = decodedToken.sub.email;
        await this.getPlanOd(this.customerPlansId);
        await this.getCustomerPlan(this.planOdId);
        await this.getGalleryVideos(this.planOdId);
        await this.getGallery(this.planOdId);
        await this.getIaCredits();
      }
    },
    async getGalleryVideos(planId: number) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/galleries/videos/${planId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });

        // eslint-disable-next-line max-len
        const videoFilter = response.data.filter(
          (item: any) => Number(item.id) === Number(this.$route.params.id),
        );
        // eslint-disable-next-line prefer-destructuring
        const video = videoFilter[0];
        await this.selectVideo(video);
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async logUserAction(action: string, status: string, description: string) {
      try {
        const logData = {
          id_customers: this.id_customer,
          username: this.username,
          action,
          status,
          description,
        };

        await registerLog(logData);
        console.log('Log registrado com sucesso!');
      } catch (error) {
        console.error('Erro ao registrar o log:', error);
      }
    },
    async getPlanOd(customerPlansId: any) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/event/getPlanOd/${customerPlansId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });
        this.planOdId = response.data.customerPlansOdId;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async getCustomerPlan(id: string | number) {
      const response = await userService.getCustomerPlan(id);
      this.secretPlayer = response.data.data.secret;
    },
    showToast(key: string, type: string) {
      const text = this.$t(key);
      this.$store.dispatch('notification/create', {
        text,
        type,
      });
    },
    selectCredits(amount: any) {
      this.selectedCredits = amount;
    },
    async getIaCredits() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/iacredits/findByIdCustomer/${this.id_customer}`,
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );
        this.creditsAvailable = response.data.credits;
        this.creditsToPurchase = this.creditsAvailable > this.videoCredits
          ? 0
          : Math.abs(this.creditsAvailable - this.videoCredits);
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    updateCredits(purchasedCredits: number) {
      this.creditsAvailable += purchasedCredits; // Atualizar créditos
    },
    async getProgress() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/getProgress/${this.selectedVideo.hash}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });
        this.progress = response.data.progress;
        if (this.progress >= 100) {
          this.stopProgressPolling();
          await this.userInformation();
          this.showToast('Transcription completed', 'success');
        }
      } catch (error) {
        console.error('Erro ao obter o progresso:', error);
      }
    },
    startProgressPolling() {
      this.intervalId = setInterval(() => {
        this.getProgress();
      }, 5000);
    },

    stopProgressPolling() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    async purchaseCredits() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.put(
          `${apiUrl}/iacredits/insert`,
          {
            idCustomer: this.id_customer,
            credits: this.selectedCredits.toString(),
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );

        if (response.status === 200) {
          await this.getIaCredits();
          await this.selectVideo(this.selectedVideo);
          this.showPurchaseModal = false;
          this.showModal = false;
          this.selectedCredits = 0;
          this.showToast('Credits purchased successfully', 'success');
          await this.logUserAction(
            'Purchase',
            'Sucesso',
            `Foram comprados ${this.selectedCredits} créditos.`,
          );
        } else {
          console.error('Failed to purchase credits');
          this.showToast('Failed to purchase credits', 'error');
          await this.logUserAction(
            'Purchase',
            'Error',
            `Erro ao comprar ${this.selectedCredits} créditos.`,
          );
        }
      } catch (error) {
        console.error('Error:', error);
      }
    },
    async generateTranscriptIa(transcriptAgain: boolean) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.put(
          `${apiUrl}/iacredits/subtract`,
          {
            idCustomer: this.id_customer,
            planId: this.planOdId,
            credits: this.videoCredits.toString(),
            language: this.selectedLanguage,
            videoHash: this.selectedVideo.hash,
            storageHash: this.selectedVideo.storage_hash,
            transcriptAgain,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );

        if (response.status === 200) {
          this.showPurchaseModal = false;
          this.showConfirmation = false;
          this.showModal = false;
          this.showConfirmationAgain = false;
          this.progress = 1;
          await this.getIaCredits();
          await this.selectVideo(this.selectedVideo);
          this.progress = 5;
          localStorage.removeItem('subtitles');
          setTimeout(() => {
            this.startProgressPolling();
          }, 20000);
          this.showToast(
            'Transcription started, it will soon be available on your video.',
            'success',
          );
          await this.logUserAction(
            'Credits spent',
            'Sucesso',
            `Foram gastos ${this.videoCredits.toString()} créditos para realizar a transcrição do vídeo ${
              this.selectedVideo.name
            } com hash ${this.selectedVideo.hash}.`,
          );
        } else {
          console.error('Failed to purchase credits');
          this.showToast('Failed to purchase credits', 'error');
          await this.logUserAction(
            'Credits spent',
            'Erro',
            `Erro ao gastar ${this.videoCredits.toString()} créditos para realizar a transcrição do vídeo ${
              this.selectedVideo.name
            } com hash ${this.selectedVideo.hash}.`,
          );
        }
      } catch (error) {
        console.error('Error:', error);
        this.showToast('Failed to generate transcript', 'error');
        await this.logUserAction(
          'Credits spent',
          'Erro',
          `Erro ao gastar ${this.videoCredits.toString()} créditos para realizar a transcrição do vídeo ${
            this.selectedVideo.name
          } com hash ${this.selectedVideo.hash}.`,
        );
      }
    },
    openPurchaseModal() {
      this.showModal = false;
      this.showPurchaseModal = true;
    },
    incrementCredits() {
      // eslint-disable-next-line no-plusplus
      this.creditsToPurchase++;
    },
    decrementCredits() {
      if (this.creditsToPurchase > 1) {
        // eslint-disable-next-line no-plusplus
        this.creditsToPurchase--;
      }
    },
    async getGallery(planId: number) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;

        const responseFolders = await axios.get(`${apiUrl}/galleries/${planId}?`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });

        const responseVideos = await axios.get(`${apiUrl}/galleries/videos/${planId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });

        const folders = responseFolders.data.galleries.map((gallery: any) => ({
          id: gallery.id,
          name: gallery.name,
          type: 'folder',
          expanded: false,
          videos: responseVideos.data.filter((video: any) => video.parentId === gallery.id),
          filteredVideos: responseVideos.data.filter((video: any) => video.parentId === gallery.id),
        }));

        // eslint-disable-next-line max-len
        const videosNotInFolders = responseVideos.data.filter(
          (video: any) => video.parentId === null,
        );

        this.availableItems = [
          ...folders,
          ...videosNotInFolders.map((video: any) => ({
            id: video.id,
            name: video.name,
            type: 'video',
          })),
        ];

        this.filteredItems = this.availableItems;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    // eslint-disable-next-line func-names
    filterVideos: debounce(function (this: any) {
      if (!this.searchQuery) {
        this.filteredItems = this.availableItems;
        return;
      }

      const query = this.searchQuery.toLowerCase();
      this.filteredItems = this.availableItems
        .map((item: any) => {
          if (item.type === 'folder') {
            // eslint-disable-next-line max-len
            const filteredVideos = item.videos.filter((video: any) => video.name.toLowerCase().includes(query));
            return {
              ...item,
              filteredVideos,
              expanded: filteredVideos.length > 0,
            };
          }
          return item;
        })
        .filter((item: any) => (item.type === 'folder'
          ? item.filteredVideos.length > 0
          : item.name.toLowerCase().includes(query)));
    }, 600),
    async selectVideo(video: any) {
      this.selectedVideo = video;

      const videoTimeInSeconds = this.convertTimeToSeconds(video.time);
      if (!Number.isNaN(videoTimeInSeconds)) {
        this.videoCredits = this.calculateCredits(videoTimeInSeconds);
      } else {
        console.error('Invalid video time:', video.time);
      }
      this.loadVideoUrl();
      const savedSubtitlesData = localStorage.getItem('subtitles');
      if (savedSubtitlesData) {
        const parsedData = JSON.parse(savedSubtitlesData);

        const promptMessage = this.$t('SavedEditionPrompt') as string;
        if (parsedData.videoId === this.selectedVideo.id) {
          // eslint-disable-next-line no-restricted-globals, no-alert
          if (confirm(promptMessage)) {
            this.subtitles = parsedData.subtitles;
            this.filteredSubtitles = this.subtitles;
            this.isLoadedFromLocalStorage = true;
            setTimeout(() => {
              const iframe = document.querySelector('iframe');

              if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage(
                  JSON.stringify({ public_event: 'jmvplayer-jump', jump: 0 }),
                  '*',
                );
                iframe.contentWindow.postMessage(
                  JSON.stringify({
                    public_event: 'jmvplayer-subtitle',
                    subtitles: this.filteredSubtitles,
                  }),
                  '*',
                );
              } else {
                console.error('Iframe not found or contentWindow is not accessible.');
              }
            }, 3000);
          } else {
            localStorage.removeItem('subtitles');
            this.getSubtitle();
            setTimeout(() => {
              const iframe = document.querySelector('iframe');

              if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage(
                  JSON.stringify({ public_event: 'jmvplayer-jump', jump: 0 }),
                  '*',
                );
                iframe.contentWindow.postMessage(
                  JSON.stringify({
                    public_event: 'jmvplayer-subtitle',
                    subtitles: this.filteredSubtitles,
                  }),
                  '*',
                );
              } else {
                console.error('Iframe not found or contentWindow is not accessible.');
              }
            }, 3000);
          }
        } else {
          this.getSubtitle();
          setTimeout(() => {
            const iframe = document.querySelector('iframe');

            if (iframe && iframe.contentWindow) {
              iframe.contentWindow.postMessage(
                JSON.stringify({ public_event: 'jmvplayer-jump', jump: 0 }),
                '*',
              );
              iframe.contentWindow.postMessage(
                JSON.stringify({
                  public_event: 'jmvplayer-subtitle',
                  subtitles: this.filteredSubtitles,
                }),
                '*',
              );
            } else {
              console.error('Iframe not found or contentWindow is not accessible.');
            }
          }, 3000);
        }
      } else {
        this.getSubtitle();
        setTimeout(() => {
          const iframe = document.querySelector('iframe');

          if (iframe && iframe.contentWindow) {
            iframe.contentWindow.postMessage(
              JSON.stringify({ public_event: 'jmvplayer-jump', jump: 0 }),
              '*',
            );
            iframe.contentWindow.postMessage(
              JSON.stringify({
                public_event: 'jmvplayer-subtitle',
                subtitles: this.filteredSubtitles,
              }),
              '*',
            );
          } else {
            console.error('Iframe not found or contentWindow is not accessible.');
          }
        }, 3000);
      }
    },
    async getSubtitle() {
      if (!this.isLoadedFromLocalStorage) {
        const apiUrl = process.env.VUE_APP_API_URL;
        try {
          const response = await axios.get(`${apiUrl}/transcription/${this.selectedVideo.id}`, {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          });
          this.subtitles = JSON.parse(response.data.transcription);
          this.filteredSubtitles = this.subtitles;
        } catch (error) {
          console.error('Erro ao buscar legendas:', error);
        }
      }
    },
    searchSubtitles() {
      const query = this.searchSubtitle.trim().toLowerCase();
      if (query === '') {
        this.filteredSubtitles = this.subtitles;
      } else {
        // eslint-disable-next-line max-len
        this.filteredSubtitles = this.subtitles.filter((subtitle: any) => subtitle.text.toLowerCase().includes(query));
      }
    },
    convertTimeToSeconds(time: any) {
      const [hours, minutes, seconds] = time.split(':').map(Number);
      return hours * 3600 + minutes * 60 + seconds;
    },
    calculateCredits(timeInSeconds: any) {
      const minutes = Math.ceil(timeInSeconds / 60);
      return minutes;
    },
    loadVideoUrl() {
      const env = process.env.VUE_APP_ENV || 'production';

      let baseUrl;
      if (env === 'sandbox') {
        baseUrl = 'https://player-sandbox.jmvstream.com/';
      } else if (env === 'staging') {
        baseUrl = 'https://player-staging.jmvstream.com/';
      } else {
        baseUrl = 'https://player.jmvstream.com/';
      }

      this.video.fileUrl = `${baseUrl}${this.secretPlayer}/${this.selectedVideo.hash}`;
    },
    goToTime(time: number) {
      const iframe = document.querySelector('iframe');
      if (iframe) {
        const iframeWindow = iframe.contentWindow;
        if (iframeWindow) {
          iframeWindow.postMessage({ method: 'setCurrentTime', value: time }, '*');
        }
      }
    },
    jumpToSubtitle(time: any) {
      const iframe = document.querySelector('iframe');

      if (iframe && iframe.contentWindow) {
        const jumpTimeInSeconds = Math.round(time);
        iframe.contentWindow.postMessage(
          JSON.stringify({ public_event: 'jmvplayer-jump', jump: jumpTimeInSeconds }),
          '*',
        );
        iframe.contentWindow.postMessage(
          JSON.stringify({ public_event: 'jmvplayer-subtitle', subtitles: this.filteredSubtitles }),
          '*',
        );
      } else {
        console.error('Iframe not found or contentWindow is not accessible.');
      }
    },
    async handleBlur(index: any, subtitle: any, field: any, value: any) {
      if (value !== undefined) {
        await this.updateSubtitle(index, subtitle, field, value);
        localStorage.setItem(
          'subtitles',
          JSON.stringify({
            videoId: this.selectedVideo.id,
            subtitles: this.subtitles,
          }),
        );
      } else {
        console.error('Evento não contém o valor esperado:', value);
      }
    },
    parseTimeToSeconds(timeString: string) {
      const regex = /^(\d{2}):(\d{2}):(\d{2})\.(\d{2})$/;
      const match = timeString.match(regex);
      if (match) {
        const [, hours, minutes, seconds, milliseconds] = match;
        const totalSeconds = parseInt(hours, 10) * 3600
          + parseInt(minutes, 10) * 60
          + parseInt(seconds, 10)
          + parseInt(milliseconds, 10) / 100;

        return totalSeconds.toFixed(15);
      }
      return NaN;
    },
    updateSubtitle(index: any, subtitle: any, field: any, value: any) {
      if (subtitle) {
        const iframe = document.querySelector('iframe');

        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage(
            JSON.stringify({
              public_event: 'jmvplayer-subtitle',
              subtitles: this.filteredSubtitles,
            }),
            '*',
          );
        } else {
          console.error('Iframe not found or contentWindow is not accessible.');
        }

        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
    formatTimeSubtitle(timeInSeconds: any) {
      const hours = Math.floor(timeInSeconds / 3600)
        .toString()
        .padStart(2, '0');
      const minutes = Math.floor((timeInSeconds % 3600) / 60)
        .toString()
        .padStart(2, '0');
      const seconds = (timeInSeconds % 60).toFixed(2).padStart(5, '0');
      return `${hours}:${minutes}:${seconds}`;
    },
    async saveSubtitle() {
      const apiUrl = process.env.VUE_APP_API_URL;
      try {
        await axios.put(
          `${apiUrl}/transcription/${this.selectedVideo.id}/${this.planOdId}`,
          {
            transcription: this.subtitles,
            translation: '',
            language: this.selectedLanguage,
            videoHash: this.selectedVideo.hash,
            storageHash: this.selectedVideo.storage_hash,
          },
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
              'Content-Type': 'application/json',
            },
          },
        );
        this.showToast('Subtitle saved successfully!', 'success');

        localStorage.removeItem('subtitles');
      } catch (error) {
        console.error('Erro ao salvar a transcrição:', error);
        this.showToast('An error occurred while saving the subtitle. Please try again.', 'error');
      }
    },
    formatTime(time: number) {
      const minutes = Math.floor(time / 60);
      const seconds = time % 60;
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
    generateTranscript() {
      this.showModal = true;
    },
  },
});
